import { Link, useLocation } from 'react-router-dom';
import { CalendarIcon } from '@heroicons/react/24/outline';

const FloatingDemoButton = () => {
  const location = useLocation();

  if (location.pathname === "/contact") {
    return null;
  }

  return (
    <Link
      to="/contact"
      className="fixed bottom-6 right-6 z-50 flex items-center space-x-2 bg-[#16a34a] text-white px-6 py-3 rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
    >
      <CalendarIcon className="h-5 w-5" />
      <span>Schedule Demo</span>
    </Link>
  );
};

export default FloatingDemoButton; 